import React from 'react';
import { Typography, Divider, Card, Space } from 'antd';

const { Title, Paragraph, Text } = Typography;

const PaymentPolicy: React.FC = () => {
  return (
    <div className='container mx-auto py-12 px-4'>
      <Title level={2} className='text-center mb-8'>
        Payment Policy
      </Title>

      <Card className='mb-8'>
        <Space direction='vertical' className='w-full' size='large'>
          <div>
            <Title level={4}>Accepted Payment Methods</Title>
            <Paragraph>
              At Fruit Shop, we accept the following payment methods:
            </Paragraph>
            <Paragraph>
              <Text strong>• Credit/Debit Cards:</Text> Visa, Mastercard,
              American Express
            </Paragraph>
            <Paragraph>
              <Text strong>• Digital Wallets:</Text> Apple Pay, Google Pay,
              PayPal
            </Paragraph>
            <Paragraph>
              <Text strong>• Bank Transfers:</Text> For orders above $100
            </Paragraph>
            <Paragraph>
              <Text strong>• Cash on Delivery:</Text> Available for selected
              areas (additional COD fee may apply)
            </Paragraph>
          </div>

          <Divider />

          <div>
            <Title level={4}>Payment Security</Title>
            <Paragraph>
              We take your payment security seriously. Our website uses
              industry-standard SSL encryption to protect your personal
              information. We do not store your full credit card details on our
              servers. All payment transactions are processed through secure and
              PCI-compliant payment gateways.
            </Paragraph>
          </div>

          <Divider />

          <div>
            <Title level={4}>Billing Information</Title>
            <Paragraph>
              The billing information you provide must match the information
              associated with your payment method. Incorrect billing information
              may result in payment failure or order delays.
            </Paragraph>
          </div>

          <Divider />

          <div>
            <Title level={4}>Order Processing</Title>
            <Paragraph>
              <Text strong>• Online Payments:</Text> Your order will be
              processed immediately after successful payment confirmation.
            </Paragraph>
            <Paragraph>
              <Text strong>• Bank Transfers:</Text> Your order will be processed
              once we receive confirmation of the transfer.
            </Paragraph>
            <Paragraph>
              <Text strong>• Cash on Delivery:</Text> Your order will be
              processed upon placement, but payment will be collected at the
              time of delivery.
            </Paragraph>
          </div>

          <Divider />

          <div>
            <Title level={4}>Failed Payments</Title>
            <Paragraph>
              If your payment fails, your order will not be processed. You will
              receive a notification and can try again with the same or a
              different payment method.
            </Paragraph>
          </div>

          <Divider />

          <div>
            <Title level={4}>Refund Policy</Title>
            <Paragraph>
              <Text strong>• Successful Refunds:</Text> Refunds will be
              processed to the original payment method used for the purchase.
            </Paragraph>
            <Paragraph>
              <Text strong>• Credit/Debit Cards:</Text> Refunds typically take
              5-10 business days to appear on your statement, depending on your
              bank's policies.
            </Paragraph>
            <Paragraph>
              <Text strong>• Digital Wallets:</Text> Refunds typically appear
              within 2-3 business days.
            </Paragraph>
          </div>
        </Space>
      </Card>

      <div className='text-center'>
        <Paragraph type='secondary'>
          This payment policy was last updated on October 1, 2023. We reserve
          the right to make changes to our payment policy at any time.
        </Paragraph>
      </div>
    </div>
  );
};

export default PaymentPolicy;
